import {
  Autocomplete,
  Box,
  Drawer,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Cancel, CheckCircle } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import { useBlocker, useOutletContext } from "react-router-dom";
import ListServicosHostsConfig from "./listServicos";
import api from "../../../../services/api";
import DetailsViewHostsConfig from "./hostDetails";
import ConfusedMale from "../../../../components/artsPersonComponent/confusedMale";
import InformationMale from "../../../../components/artsPersonComponent/informationMale";
import useStyles from "./styles";
import LoaderThreeDots from "../../../../components/loadingAnimation";
import InternoModalConfirmacaoSaida from "../../../../components/modalSaindoDaPagina";

const ERP = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";
const labelErp =
  ERP === "HUBSOFT"
    ? "Serviços"
    : ERP === "VOALLE"
      ? "Contrato"
      : ERP === "IXC"
        ? "Contrato"
        : "Serviços";

export default function HostsConfig() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const matches750 = useMediaQuery("(max-width:750px)");
  const {
    setSnackbar,
    selectedCliente: clienteInfo,
    setSelectedCliente: setClienteInfo,
    changed: changedP,
    searchTerm,
    setSearchTerm,
    setChanged: setChangedP,
    serviceFilter,
    setServiceFilter,
    services,
    setServices,
    setValue,
    allServices,
    setAllServices,
    selectedService,
    setSelectedService,
    allService,
    setAllService,
    selectService,
    setSelectService,
    selectStatus,
    setSelectStatus,
    allHostsCliente,
    setAllHostsCliente,
    selectedHost,
    setSelectedHost,
    syncRefreshTrigger,
    setSyncRefreshTrigger,
    setIsEditing,
    syncRunning,
    showCanceled,
    setShowCanceled,
    urlServiceId,
    configStatusFilter,
  } = useOutletContext();
  const [editMode, setEditMode] = useState(false);
  const [selectedServiceLocal, setSelectedServiceLocal] = useState(null);

  // Sincroniza o estado de edição com o componente pai (perfil/index.js)
  useEffect(() => {
    setIsEditing?.(editMode);
  }, [editMode]);

  // Inicializa/sincroniza o serviço local a partir do urlServiceId ou selectedService
  useEffect(() => {
    const targetSid = selectedService?.id_cliente_servico ?? selectedService?.id ?? urlServiceId;
    if (targetSid && allServices?.length > 0) {
      const found = allServices.find(
        (s) => String(s?.id_cliente_servico ?? s?.id) === String(targetSid),
      );
      if (found) {
        const currentSid = selectedServiceLocal?.id_cliente_servico ?? selectedServiceLocal?.id;
        if (String(currentSid) !== String(targetSid)) {
          setSelectedServiceLocal(found);
        }
      }
    } else if (!targetSid && selectedServiceLocal) {
      setSelectedServiceLocal(null);
    }
  }, [urlServiceId, selectedService, allServices]);


  const [loading, setLoading] = useState({
    onuFromErp: false,
    initialData: false,
    allServices: false,
    cpe: false,
    links: false,
    sessions: false,
    linksAndSessions: false,
  });
  /** LISTAR SERVIÇOS */

  const [filteredServices, setFilteredServices] = useState([]);
  /** LISTAR INTERFACES */
  const [interfaceList, setInterfaceList] = useState({
    cpes: {},
    links: {},
    sessions: {},
  });
  /** MANIPULAR HOSTS */
  // Listar modelos disponíveis
  const [availableDevices, setAvailableDevices] = useState({
    cpes: [],
    onus: [],
  });
  // Listar hosts disponíveis
  const [availableHosts, setAvailableHosts] = useState({
    cpes: [],
    onus: [],
  });
  // Dados já cadastrados
  const [initialData, setInitialData] = useState({
    cpes: [],
    onus: [],
    links: [],
    sessions: [],
  });

  /** CONFIRMAR ALTERAÇÕES PENDENTES */
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [changed, setChanged] = useState(true);
  const pendingNavigation = useRef(null);

  // Bloquear navegação se houver alterações
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return (
      currentLocation.pathname !== nextLocation.pathname && editMode && changed
    );
  });

  // Mostra modal quando bloquear e marca que é navegação de rota
  useEffect(() => {
    if (blocker?.state === "blocked") {
      pendingNavigation.current = { type: "route" };
      setConfirmacaoSaidaPagina(true);
    }
  }, [blocker?.state]);

  // Confirmar saída
  const handleConfirmNavigation = () => {
    setEditMode(false);
    setConfirmacaoSaidaPagina(false);
    setChanged(false);

    // Navegar / liberar bloqueio
    if (pendingNavigation.current?.type === "route") {
      pendingNavigation.current = null;
      blocker?.proceed?.();
      return;
    }

    // Trocar de serviço selecionado
    if (pendingNavigation.current?.type === "accordion") {
      const nextService = pendingNavigation.current.to;
      pendingNavigation.current = null;
      setSelectedServiceLocal(nextService);
      return;
    }

    // Fechar o drawer
    if (pendingNavigation.current?.type === "close-drawer") {
      pendingNavigation.current = null;
      setSelectedServiceLocal(null);
      return;
    }
  };

  // Cancelar saída
  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
    setValue(1); // Selecionar aba de hosts
    if (blocker?.reset) {
      blocker?.reset();
    }
    pendingNavigation.current = null;
  };

  // Executar ao carregar
  useEffect(() => {
    setSelectedServiceLocal(null);
    Promise.all([
      getAllServicessClient({
        loading,
        setAllServices,
        cnpj: clienteInfo?.cnpj,
        clienteErpId: clienteInfo?.clienteErpId,
        clienteId: clienteInfo?.id,
        setSnackbar,
      }),
      handleApiGetHosts({
        loading,
        setSnackbar,
        setAvailableHosts,
        setAvailableDevices,
      }),
      handleApiInitialData({
        loading,
        setSnackbar,
        clienteInfo,
        setInitialData,
      }),
    ]);
  }, [clienteInfo?.id]);

  // Recarrega initialData quando a sincronização finalizar e o usuário confirmar
  useEffect(() => {
    if (syncRefreshTrigger) {
      // Recarrega os dados do Zabbix de forma silenciosa
      handleApiInitialData({
        loading,
        setSnackbar,
        clienteInfo,
        setInitialData,
      });
      setSyncRefreshTrigger(false);
    }
  }, [syncRefreshTrigger]);

  useEffect(() => {
    // Mesmo comportamento da aba Circuito: ao filtrar por um serviço na barra
    // superior, mostra somente ele na lista (já selecionado), ignorando os
    // demais filtros (Mostrar Cancelados / Configuração) — uma seleção
    // explícita não deve ser escondida por eles, senão a tela mostra "nenhum
    // serviço encontrado" mesmo com o serviço existindo.
    const selectedServiceId =
      selectedService?.id_cliente_servico ?? selectedService?.id ?? urlServiceId;
    if (
      selectedServiceId !== undefined &&
      selectedServiceId !== null &&
      selectedServiceId !== ""
    ) {
      setFilteredServices(
        allServices?.filter(
          (contrato) => String(contrato?.id) === String(selectedServiceId),
        ) || [],
      );
      return;
    }

    let filtered = allServices;

    if (!showCanceled) {
      filtered = filtered?.filter(
        (service) =>
          !String(service?.status || "")
            .toLowerCase()
            .includes("cancelado"),
      );
    }

    if (configStatusFilter === "configurado") {
      filtered = filtered?.filter((contrato) => {
        const isConfigured =
          initialData?.cpes?.[contrato?.id]?.some(h => h?.hostId || h?.hostid) ||
          initialData?.onus?.[contrato?.id]?.some(h => h?.hostId || h?.onuItem) ||
          initialData?.links?.[contrato?.id]?.some(h => h?.hostId || h?.hostid) ||
          initialData?.sessions?.[contrato?.id]?.some(h => h?.hostId || h?.hostid);
        return isConfigured;
      });
    } else if (configStatusFilter === "nao_configurado") {
      filtered = filtered?.filter((contrato) => {
        const isConfigured =
          initialData?.cpes?.[contrato?.id]?.some(h => h?.hostId || h?.hostid) ||
          initialData?.onus?.[contrato?.id]?.some(h => h?.hostId || h?.onuItem) ||
          initialData?.links?.[contrato?.id]?.some(h => h?.hostId || h?.hostid) ||
          initialData?.sessions?.[contrato?.id]?.some(h => h?.hostId || h?.hostid);
        return !isConfigured;
      });
    }

    setFilteredServices(filtered);
  }, [
    allServices,
    showCanceled,
    configStatusFilter,
    initialData,
    selectedService,
    urlServiceId,
  ]);

  return (
    <Box>
      {/** Mostrar/Ocultar cancelados */}
      {allServices?.length > 0 && (
        <Box sx={styles.boxSwitch}>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  sx={styles.switch}
                  checked={showCanceled}
                  onChange={(e) => setShowCanceled(e.target.checked)}
                  checkedIcon={
                    <CheckCircle sx={{ fontSize: 22, color: "#fff" }} />
                  }
                  icon={<Cancel sx={{ fontSize: 22, color: "#fff" }} />}
                  focusVisibleClassName=".Mui-focusVisible"
                  disableRipple
                />
              }
              label={
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    ml: 1,
                    color: showCanceled ? "text.primary" : "text.secondary",
                    fontSize: "0.85rem",
                    userSelect: "none",
                  }}
                >
                  {showCanceled ? "Ocultar Cancelados" : "Mostrar Cancelados"}
                </Typography>
              }
              sx={{ margin: 0 }}
            />
          </FormGroup>
        </Box>
      )}
      {/** Nenhum serviço */}
      {filteredServices?.length === 0 ||
        !!loading?.allServices ||
        !!loading?.initialData ||
        !!loading?.cpe ? (
        !!loading?.allServices || !!loading?.initialData || !!loading?.cpe ? (
          <LoaderThreeDots />
        ) : (
          <ConfusedMale
            mainFill={theme.palette.secondary.dark}
            primaryCircleFill={theme.palette.secondary.main}
            highlightTitle={"Oops!"}
            subtitle={`Parece que não\nencontramos nenhum\n${labelErp.toLocaleLowerCase()} para realizar\nconfiguração.`}
          />
        )
      ) : (
        <Grid container spacing={1}>
          {/** Servicos */}

          <Grid item xs={12} sm={matches750 ? 12 : 4} md={4} lg={4}>
            <ListServicosHostsConfig
              loading={loading}
              changed={changed}
              editMode={editMode}
              setLoading={setLoading}
              selectedService={selectedServiceLocal}
              filteredServices={filteredServices}
              pendingNavigation={pendingNavigation}
              setSelectedService={setSelectedServiceLocal}
              setConfirmacaoSaidaPagina={setConfirmacaoSaidaPagina}
              initialData={initialData}
            />
          </Grid>
          {/** Propriedades de configuração */}
          <Grid item xs={8}>
            {!selectedServiceLocal ? (
              !matches750 && (
                <Paper
                  elevation={theme.palette.mode === "dark" ? 0 : 3}
                  sx={styles.paperInformation}
                >
                  <InformationMale
                    mainFill={theme.palette.secondary.dark}
                    primaryCircleFill={theme.palette.secondary.main}
                    secondaryCircleFill={theme.palette.secondary.light}
                    title={"Você ainda não selecionou um"}
                    highlight={"circuito"}
                    subtitle={
                      "As informações de circuito aparecerão aqui assim\nque um cliente for escolhido."
                    }
                  />
                </Paper>
              )
            ) : matches750 ? (
              <Drawer anchor="right" open={true} sx={styles.drawer}>
                <DetailsViewHostsConfig
                  setInterfaceList={setInterfaceList}
                  interfaceList={interfaceList}
                  loading={loading}
                  changed={changed}
                  editMode={editMode}
                  setChanged={setChanged}
                  setEditMode={setEditMode}
                  setSnackbar={setSnackbar}
                  initialData={initialData}
                  clienteInfo={clienteInfo}
                  availableHosts={availableHosts}
                  selectedService={selectedServiceLocal}
                  availableDevices={availableDevices}
                  filteredServices={filteredServices}
                  pendingNavigation={pendingNavigation}
                  setSelectedService={setSelectedServiceLocal}
                  setConfirmacaoSaidaPagina={setConfirmacaoSaidaPagina}
                  syncRunning={syncRunning}
                />
              </Drawer>
            ) : (
              <DetailsViewHostsConfig
                setInterfaceList={setInterfaceList}
                interfaceList={interfaceList}
                loading={loading}
                changed={changed}
                editMode={editMode}
                setChanged={setChanged}
                setEditMode={setEditMode}
                setSnackbar={setSnackbar}
                initialData={initialData}
                clienteInfo={clienteInfo}
                availableHosts={availableHosts}
                selectedService={selectedServiceLocal}
                availableDevices={availableDevices}
                filteredServices={filteredServices}
                pendingNavigation={pendingNavigation}
                setSelectedService={setSelectedServiceLocal}
                setConfirmacaoSaidaPagina={setConfirmacaoSaidaPagina}
                syncRunning={syncRunning}
              />
            )}
          </Grid>
        </Grid>
      )}
      {/* Modal de aviso de saída */}
      <InternoModalConfirmacaoSaida
        confirmLoad={false}
        cancel={handleCancelNavigation}
        execute={handleConfirmNavigation}
        openConfirmacao={confirmacaoSaidaPagina}
        setOpenConfirmacao={setConfirmacaoSaidaPagina}
        title={"Atenção"}
        severity={"warning"}
        confirmText={"Continuar"}
        headerText={"Você está prestes a sair do modo de edição."}
        contentText={
          "As alterações não salvas serão perdidas, deseja continuar?"
        }
      />
    </Box>
  );
}

/** LISTAR SERVIÇOS */
async function getAllServicessClient({
  cnpj,
  loading,
  setSnackbar,
  clienteErpId,
  clienteId,
  setAllServices,
}) {
  try {
    loading.allServices = true;
    const response = await api.post("/interno/find/allServiceClient", {
      cnpj: cnpj,
      idClienteErp: clienteErpId,
      clienteId: clienteId,
      includeInactive: true,
    });

    const services = Array.isArray(response?.data)
      ? response.data.map((item) => ({
        id: item?.id_cliente_servico,
        nome: item?.nome,
        status: item?.status,
        referencia: item?.referencia,
        invertInfo: item?.invertInfo,
        ownerClienteId: item?.ownerClienteId,
        ownerNome: item?.ownerNome,
      }))
      : [];

    setAllServices(services);
  } catch (error) {
    console.error(error);
    setSnackbar({
      children: `Error: Não foi possível listar os serviços. `,
      severity: "error",
    });
  } finally {
    loading.allServices = false;
  }
}

/** OBTER HOSTS */
async function handleApiGetHosts({
  loading,
  setSnackbar,
  setAvailableHosts,
  setAvailableDevices,
}) {
  try {
    loading.cpe = true;

    const [hostList, allModels] = await Promise.all([
      api.post("/zabbix/hostList", {}),
      api.post("/zabbix/groupList", {}),
    ]);

    const { cpeHosts, onuHosts } = (hostList?.data || []).reduce(
      (acc, item) => {
        if (item.host.startsWith("OLT")) {
          acc.onuHosts.push(item);
        } else {
          acc.cpeHosts.push(item);
        }
        return acc;
      },
      { cpeHosts: [], onuHosts: [] },
    );

    const { cpes, onus } = (allModels?.data || []).reduce(
      (acc, item) => {
        if (item.name.startsWith("OLT")) {
          acc.onus.push(item);
        } else {
          acc.cpes.push(item);
        }
        return acc;
      },
      { cpes: [], onus: [] },
    );

    setAvailableDevices({ cpes, onus });
    setAvailableHosts({ cpes: cpeHosts, onus: onuHosts });
  } catch (error) {
    console.error(error);
    setSnackbar({
      children: `Error:${" Não foi possível buscar os hosts."} `,
      severity: "error",
    });
  } finally {
    loading.cpe = false;
  }
}

/** RECEBER DADOS INICIAIS */
async function handleApiInitialData({
  loading,
  clienteInfo,
  setSnackbar,
  setInitialData,
}) {
  try {
    loading.initialData = true;
    const response = await api.post("/interno/findMany/hostsCliente", {
      clienteId: clienteInfo?.id,
      includeEmptyHosts: true,
      mapHostsByServiceAndEquipmentType: true,
      includeInterfaceTags: true,
    });

    setInitialData(response?.data || { cpes: {}, onus: {} });
  } catch (error) {
    console.error(error);
    setSnackbar({
      children: `Error: Não foi possível buscar os dados iniciais.`,
      severity: "error",
    });
  } finally {
    loading.initialData = false;
  }
}
